var map = {
	"./01_trade_info.json": "tk7z",
	"./02_kline_data.json": "klxE",
	"./03_depth_info.json": "ADmP",
	"./04_24hr_ticker.json": "7Biw",
	"./05_last_price.json": "q1yk",
	"./06_book_ticker.json": "vVRe",
	"./07_depth_incr_info.json": "MY8u"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TUnK";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/market \.json$
// module id = TUnK
// module chunks = 3